import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationModule  } from '@navigation';
import { NotificationModule } from '@notification';
import { UiFormatModule } from '@ui-format';
import { CLFooter } from './footer.component';
import { CLHeader } from './header.component';
import { CLHeaderMinimal } from './header.minimal.componet';
import { CxFormsModule } from '@forms';

@NgModule({
    imports: [
        NavigationModule,
        NotificationModule,
        CommonModule,
        UiFormatModule,
        CxFormsModule
    ],
    declarations: [
        CLFooter,
        CLHeader,
        CLHeaderMinimal
    ],
    exports: [
        CLFooter,
        CLHeader,
        CLHeaderMinimal
    ],
    providers : [
    ]
})
export class UiPartsModule {}

export {
    CLFooter,
    CLHeader,
    CLHeaderMinimal
};
